import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../store/actions'
import { NavLink } from 'react-router-dom'
import DefaultLayout from '../../layouts/default'
import ButtonPrimary from '../../components/buttons/primary'
import Social from '../../components/social'
import Swiggle from '../../images/ico-swiggle.svg'
import Gallery from '../../components/gallery'
import Rating from '../../components/rating'
import ArtistHotspot from '../../components/artist-hotspot'
import Loading from '../../components/loading'

function mapStateToProps(state) {
  return { page: state.pageSlugData[0], pages: state.pagesData, artPosts: state.posts.data };
}

const mapDispatchToProps = (dispatch) => {
  const {fetchPageBySlug,fetchPosts} = actions;
  return {
    fetchPageBySlug: bindActionCreators(fetchPageBySlug, dispatch),
    fetchPosts: bindActionCreators(fetchPosts, dispatch)
  }
}

class Home extends React.Component {
  constructor() {
    super();

    this.state = {
      loaded: false
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ loaded: true })
    }, 1400)
  }

  componentWillMount() {
    this.props.fetchPageBySlug('home');
    this.props.fetchPosts({
      'categories': '11',
      'per_page': '12',
      '_embed': 'true'
    });
  }

  render() {
    const { page, artPosts } = this.props

    if (!page || !artPosts || !this.state.loaded) { return <Loading /> }

    const { headline } = page.acf || null

    return (
      <DefaultLayout>
        <section className="hero">
          <div className="container container--grid">
            <div className="row">
              <div className="col hero__content">
                <h1 className="hero__headline reveal-text">{headline}</h1>
                <div className="hero__button--container">
                  <ButtonPrimary className="hero__button" to="contact">reserve your seat</ButtonPrimary>
                </div>
                <div className="hero__rating">
                  <Rating count="5"/>
                </div>
              </div>
            </div>
          </div>
          <div className="hero__social">
            <Social instagram="trapinktattoos" facebook="trapinktattoos" />
            <img className="hero-social__swiggle" src={ Swiggle } alt="swiggle"/>
            <span>social</span>
          </div>
        </section>
        <section className="about container container--grid">
          <div className="about__artwork">
            <Gallery posts={ artPosts } />
          </div>
          <div className="row">
            <div className="col col--md-8 col--md-push-2 about__content">
              <p dangerouslySetInnerHTML={{ __html: page.content.rendered }}></p>
              <NavLink to="our-history">Continue reading...</NavLink>
            </div>
          </div>
        </section>
        <section className="container container--grid">
          <div className="row">
            <ArtistHotspot pages={ this.props.pages } slider="true" />
          </div>
        </section>
      </DefaultLayout>
    );
  }

}

export default connect(
  mapStateToProps,
  mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/routes/home/index.js